import React, { useState, useEffect, useRef, forwardRef } from "react";
import Footer from "../../../../components/home_page/Footer";
import InputField from "../../../../components/Input/InputField";
import { useDispatch } from "react-redux";
import { closeModal } from "../../../../redux/actions/action-creator";

const fallbackInputFields = [
  ...Array(25).fill({}),
  { label: "Order No", name: "order_no", type: "text", isRequired: true },
  {
    label: "Mode of Term Payment",
    name: "mode_term_payment",
    type: "text",
    isRequired: true,
  },
  {
    label: "Other Reference",
    name: "other_reference",
    type: "text",
    isRequired: true,
  },
  {
    label: "Term of Delivery",
    name: "term_of_delivery",
    type: "text",
    isRequired: true,
  },
];

const OrderDetails = forwardRef((props, ref_name) => {
  const dispatch = useDispatch();

  const handleModalClose = (focusTarget) => {
    // Check if any order detail fields have data
    const hasOrderData =
      props.data?.order_no ||
      props.data?.mode_term_payment ||
      props.data?.other_reference ||
      props.data?.term_of_delivery;

    // Update order_detail/order_details status based on whether data exists
    if (!hasOrderData) {
      if (props.data?.order_detail === "Available") {
        props.setData((prev) => ({
          ...prev,
          order_detail: "Not Available",
        }));
      }
      if (props.data?.order_details === "Available") {
        props.setData((prev) => ({
          ...prev,
          order_details: "Not Available",
        }));
      }
    }

    dispatch(closeModal("order_detail_modal"));
    if (props.setshow_order_details_modal) {
      props.setshow_order_details_modal(false);
    }

    // Focus on the target element (first item field or provided ref)
    const target =
      focusTarget || (ref_name && ref_name.current) || props.ref_name?.current;
    if (target && target.focus) {
      setTimeout(() => {
        target.focus();
        if (target.setSelectionRange) {
          target.setSelectionRange(0, target.value?.length || 0);
        }
      }, 50);
    } else {
      // Focus on the first item name field (for Sales.js and Purchase.js)
      const firstRowId = props.data?.data_item?.[0]?.id;
      const nextRef = props.dynamicInputRef?.current?.[firstRowId]?.item_name;
      if (nextRef && nextRef.focus) {
        setTimeout(() => {
          nextRef.focus();
          if (nextRef.setSelectionRange) {
            nextRef.setSelectionRange(0, nextRef.value?.length || 0);
          }
        }, 50);
      }
    }
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "a") {
        e.preventDefault();
        e.stopPropagation();
        handleModalClose();
        return;
      }

      if (e.key === "Escape") {
        e.preventDefault();
        handleModalClose();
        e.stopPropagation();
      }
    };
    document.addEventListener("keydown", handleKeyDown, true);
    return () => {
      document.removeEventListener("keydown", handleKeyDown, true);
    };
  }, [dispatch, props]);

  return (
    <div className="my-card">
      <div className="cross_button" onClick={() => handleModalClose()}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-x"
          viewBox="0 0 16 16"
        >
          <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
        </svg>
      </div>
      <div
        className="container pb-3 border border-dark"
        id="card-period"
        style={{ width: "60%", background: "#fff" }}
      >
        <div className="row">
          <div className="col border-bottom">
            <b>Order Details</b>
          </div>
        </div>
        <div className="row">
          <div className="col">
            {(props.inputFields || fallbackInputFields)
              .slice(25, 29)
              .map(({ label, name, type, isRequired }, index) => (
                <InputField
                  height="3vh"
                  key={index}
                  lable={label}
                  type={type}
                  name={name}
                  value={props.data[name] || ""}
                  handleChange={props.handleChange}
                  handleBlur={props.handleBlur}
                  handleFocus={props.handleFocus}
                  isRequired={isRequired}
                  handleKeyDown={props.handleKeyDown}
                  ref={props.inputRefs[name]}
                />
              ))}
          </div>
        </div>
      </div>
      <div className="tomasterfooter" style={{ background: "red" }}>
        <Footer />
      </div>
    </div>
  );
});

export default OrderDetails;
